/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import { useTranslation } from "react-i18next";
import Reveal from "./Reveal";
import { payments } from "../payments/payments.data";

export default function PaymentsStrip({ isArabic }) {
  const { t } = useTranslation();

  return (
    <section className="gl-section" style={{ paddingTop: 0, paddingBottom: "clamp(2rem, 5vw, 3rem)" }}>
      <div className="gl-shell">
        <Reveal>
          <div className="gl-pay-strip">
            <span className="gl-pay-strip__label">
              {isArabic ? "طرق الدفع المدعومة" : "Supported payments"}
            </span>
            {payments.map((p) => (
              <div className="gl-pay-strip__item" key={p.nameEn}>
                <img src={p.img} alt={isArabic ? p.nameAr : p.nameEn} />
                <span>{isArabic ? p.nameAr : p.nameEn}</span>
              </div>
            ))}
            <span className="gl-pay-strip__label" style={{ opacity: 0.7 }}>
              {t("footer.location")}
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
